<template>
  <div
    aria-live="polite"
    class="layout message-list column fill-height scroll-container"
  >
    <message
      ref="messages"
      v-for="message in messages"
      :message="message"
      :key="message.id"
      :class="`message-${message.type}`"
      @scrollDown="scrollDown"
    ></message>
    <MessageLoading v-if="loading"></MessageLoading>
  </div>
</template>

<script>
import Message from './Message';
import MessageLoading from './MessageLoading';

export default {
  name: 'message-list',
  components: {
    Message,
    MessageLoading,
  },
  computed: {
    messages() {
      return this.$store.state.messages;
    },
    loading() {
      return this.$store.state.lex.isProcessing || this.$store.state.liveChat.isProcessing;
    },
  },
  watch: {
    messages: {
      handler() {
        this.$nextTick(this.scrollDown);
      },
      deep: true
    },
    loading() {
      this.$nextTick(this.scrollDown);
    },
  },
  mounted() {
    // Initial scroll to bottom with a slight delay to ensure all content is rendered
    setTimeout(() => {
      this.scrollDown();
    }, 1000);
    
    // Add resize observer to handle dynamic content changes
    this.resizeObserver = new ResizeObserver(() => {
      this.scrollDown();
    });
    
    // Observe the container for size changes
    if (this.$el) {
      this.resizeObserver.observe(this.$el);
    }
  },
  beforeUnmount() {
    // Clean up the resize observer when component is destroyed
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  },
  methods: {
    scrollDown() {
      this.$nextTick(() => {
        const container = this.$el;
        if (container) {
          // Use smooth scrolling for better user experience
          container.scrollTo({
            top: container.scrollHeight,
            behavior: 'smooth'
          });
          
          // Fallback for browsers that don't support smooth scrolling
          if (container.scrollTop !== container.scrollHeight) {
            container.scrollTop = container.scrollHeight;
          }
        }
      });
    }
  }
};
</script>

<style scoped>
.scroll-container {
    height: 100%;
    max-height: none;
    overflow-y: auto !important;
    overflow-x: hidden !important;
    scrollbar-width: thin;
    scrollbar-color: #888 #f0f0f0;
    -webkit-overflow-scrolling: touch;
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    padding-bottom: 80px; /* Increased padding at the bottom to prevent content from being cut off */
    position: relative;
}

.scroll-container::-webkit-scrollbar {
    width: 8px;
    z-index: 99999;
}

.scroll-container::-webkit-scrollbar-track {
    background: #f0f0f0;
    border-radius: 10px;
    z-index: 99999;
}

.scroll-container::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 10px;
    z-index: 99999;
}

.scroll-container::-webkit-scrollbar-thumb:hover {
    background: #555;
    z-index: 99999;
}

.message-list {
  padding: 16px;
  padding-bottom: 100px; /* Extra padding at the bottom to ensure content isn't cut off */
  overflow-y: auto !important;
  overflow-x: hidden !important;
  background-color: white;
  scrollbar-width: thin;
  scrollbar-color: rgba(66, 133, 244, 0.3) transparent;
  height: 100%;
  min-height: 0;
  -webkit-overflow-scrolling: touch;
  scroll-behavior: smooth;
  background-image: linear-gradient(to bottom, rgba(245, 247, 250, 0.5), rgba(245, 247, 250, 0.2));
  max-width: 100%;
  position: relative;
  flex: 1 1 auto;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}

.message-list::-webkit-scrollbar {
  width: 6px;
  z-index: 99999;
}

.message-list::-webkit-scrollbar-track {
  background: transparent;
  border-radius: 10px;
  z-index: 99999;
}

.message-list::-webkit-scrollbar-thumb {
  background-color: rgba(66, 133, 244, 0.3);
  border-radius: 10px;
  border: 2px solid transparent;
  background-clip: content-box;
  z-index: 99999;
}

.message-list::-webkit-scrollbar-thumb:hover {
  background-color: rgba(66, 133, 244, 0.5);
  z-index: 99999;
}

.layout {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
}

.fill-height {
  height: 100%;
  min-height: 0;
  flex: 1 1 auto;
  overflow: hidden;
}
</style>